const React = require('react');

const ContactError = () => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <rect id="5n0kdnehua" width="24" height="24" x="0" y="0" rx="12" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-168 -614) translate(168 614)">
          <mask id="50qmckmajb" fill="#fff">
            <use xlinkHref="#5n0kdnehua" />
          </mask>
          <use fill="#F23D4F" xlinkHref="#5n0kdnehua" />
          <path fill="#FFF" fillRule="nonzero" d="M12.005 15.255c.803 0 1.454.65 1.454 1.454 0 .803-.651 1.455-1.454 1.455-.804 0-1.455-.652-1.455-1.455s.651-1.454 1.455-1.454zM13.459 5.8l-.364 8h-2.181l-.364-8h2.91z" mask="url(#50qmckmajb)" />
        </g>
      </g>
    </g>
  </svg>
);

module.exports = ContactError;
